// setTimeout(() => {
//    const scrollContainer = document.querySelector('.cart-grid--mini-cart .cart-grid__items');
//    scrollContainer.style.overflowY = 'hidden';
//    scrollContainer.offsetHeight; // Trigger reflow
//    scrollContainer.style.overflowY = 'auto';
//    console.log("hello scroller");
//  }, 200);

// window.onload = function() {
//   const scrollContainer = document.querySelector('.cart-grid--mini-cart .cart-grid__items');
//   scrollContainer.style.overflowY = 'hidden';
//   setTimeout(() => {
//     scrollContainer.style.overflowY = 'auto';
//   }, 5000);
// };

// window.onload = function() {
//   const scrollContainer = document.querySelector('.cart-grid--mini-cart .cart-grid__items');
//   if (scrollContainer) {
//     scrollContainer.style.overflowY = 'hidden'; // Temporarily disable scrolling
//     scrollContainer.offsetHeight; // Trigger reflow
//     scrollContainer.style.overflowY = 'auto'; // Re-enable scrolling
//   }
// };

document.addEventListener("DOMContentLoaded", function () {
  const productIcons = document.querySelectorAll(
    ".lo-product-list .product-icon"
  );
  const productDetails = document.querySelectorAll(
    ".lo-product-details-wrap .lo-product-item-details"
  );
  const productSlider = document.querySelectorAll(
    ".main-prod-slider .p-image-slider"
  );

  productIcons.forEach((icon) => {
    icon.addEventListener("click", function (e) {
      //   console.log(index);
      const id = this.getAttribute("data-id");
      // Remove 'active' class from all icons
      productIcons.forEach((item) => item.classList.remove("active"));
      productDetails.forEach((item) => item.classList.remove("active"));
      productSlider.forEach((item) => item.classList.remove("active"));

      document
        .querySelectorAll(`.lip-oasis-sec-wrap [data-id="${id}"]`)
        .forEach((item) => {
          item.classList.add("active");
        });
    });
  });
});
/*
document.addEventListener("DOMContentLoaded", function () {
  document
    .querySelectorAll(".lip-oasis-sec-wrap .lp-product-details-btn")
    .forEach((element) => {
      let dataIndex = element.getAttribute("data-index"); // Get data-index
      let innerContent = element.innerHTML; // Get innerHTML

      // Select the corresponding .lo-product-item-details using data-index
      let targetElement = document.querySelector(
        `.lo-product-details-wrap .lo-product-item-details[data-index="${dataIndex}"]`
      );

      // Append content if the target element exists
      if (targetElement) {
        targetElement.innerHTML += innerContent;
      }
    });
});
*/
document.addEventListener("DOMContentLoaded", () => {
  const slideIcons = document.querySelectorAll(
    ".slider-lp-shades .slide .slide-icon"
  );
  const slides = document.querySelectorAll(".slider-lp-shades .slide");
  const items = document.querySelectorAll(
    ".slider-lp-shades .featured-product-item"
  );
  //featured-product-item
  slideIcons.forEach((icon) => {
    icon.addEventListener("click", function (e) {
      const parentSlide = icon.closest(".slide");

      if (!parentSlide) return; // Exit if no parent slide is found

      const targetId = parentSlide.getAttribute("data-id"); // Get parent's data-id
      if (!targetId) return; // Exit if no data-id is found
      slides.forEach((slide) => slide.classList.remove("active"));
      items.forEach((item) => item.classList.remove("active"));

      document
        .querySelectorAll(
          `.slider-lp-shades .lp-slider [data-id="${targetId}"]`
        )
        .forEach((item) => {
          //  console.log(item,'Test');
            if (window.innerWidth <= 1024) { // Only execute if screen width is less than 1024px

const headerHeight = 135;
const elementPosition = item.getBoundingClientRect().top + window.scrollY;

window.scrollTo({
  top: elementPosition - headerHeight,
  behavior: "smooth"
});

            }
          item.classList.add("active");
        });
      
      document
        .querySelectorAll(
          `.slider-lp-shades .featured-product-wrap [data-id="${targetId}"]`
        )
        .forEach((item) => {
          item.classList.add("active");
        });
    });
  });
});


function moveSliderOnResize() {
  const mainSlider = document.querySelector(".lip-oasis-sec-wrap .main-prod-slider");
  const mobileSlider = document.querySelector(".lip-oasis-sec-wrap .mobile-slider");

  if (window.innerWidth <= 1024) {
    if (mainSlider && mobileSlider && !mobileSlider.contains(mainSlider)) {
      mobileSlider.appendChild(mainSlider); // Move the slider into .mobile-slider
     
    }
  }
  else {
    const originalContainer = document.querySelector(".lip-oasis-sec-wrap .m-prod--slider");
    if (originalContainer && !originalContainer.contains(mainSlider)) {
     // originalContainer.appendChild(mainSlider);
    }

  }
  
}

// Run on resize
//window.addEventListener("resize", moveSliderOnResize);

// Run on page load to check initial screen size
document.addEventListener("DOMContentLoaded", moveSliderOnResize);

// Quiz email submit button text behavior
(function () {
  const FORM = 'form.c-questionsForm--default';
  const EMAIL = 'input.c-input[type="email"]';
  const NEXT_BTN = 'button.c-questionsForm-next--email.c-questionsForm-next.c-button[type="submit"]';
  const labelFor = (v) => (v && v.trim().length ? 'Continue' : 'Skip');

  // idempotent: only sets text, never rewires DOM
  function setLabel(form) {
    if (!form) return;
    const email = form.querySelector(EMAIL);
    const btn = form.querySelector(NEXT_BTN);
    if (!email || !btn) return;
    const text = labelFor(email.value);
    // only touch text + aria (don’t touch innerHTML/children or other attrs)
    if (btn.textContent !== text) btn.textContent = text;
    const aria = btn.getAttribute('aria-label');
    if (aria !== text) btn.setAttribute('aria-label', text);
  }

  // initial pass (if popup already open)
  function scan() {
    document.querySelectorAll(FORM).forEach(setLabel);
  }

  // 1) Update as the user types (delegated so it survives rerenders)
  document.addEventListener(
    'input',
    (e) => {
      if (!(e.target instanceof HTMLInputElement)) return;
      if (!e.target.matches(EMAIL)) return;
      const form = e.target.closest(FORM);
      if (!form) return;
      // let Okendo’s handlers run first
      Promise.resolve().then(() => setLabel(form));
    },
    true
  );

  // 2) When the email field (or anything inside the step) gets focus, enforce once
  document.addEventListener(
    'focusin',
    (e) => {
      const form = e.target.closest?.(FORM);
      if (!form) return;
      // microdelay to allow Okendo to swap nodes/text, then set ours
      setTimeout(() => setLabel(form), 0);
      // short, gentle reinforcement after step change (no observers)
      let n = 0;
      const id = setInterval(() => {
        if (!document.body.contains(form) || ++n > 20) return clearInterval(id); // ~2s
        setLabel(form);
      }, 100);
    },
    true
  );

  // 3) After clicking Back/Next, re-apply label (without touching the click itself)
  document.addEventListener(
    'click',
    (e) => {
      const form = e.target.closest?.(FORM);
      if (!form) return;
      // run after Okendo navigates/updates
      setTimeout(() => setLabel(form), 50);
    },
    true
  );

  // 4) One-time initial scan (no global observers)
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scan, { once: true });
  } else {
    scan();
  }
  document.addEventListener('submit', (e) => {
    const form = e.target.closest?.(FORM);
      if (!form) return;
      const quizContainer = form.closest('[oke-channel-quiz-id="9b9a9e3e-92f6-4e04-ab67-2bd05d3b4f30"]');
      console.log('Quiz Container Found:', quizContainer);
      if (!quizContainer) return;
      const emailInput = form.querySelector(EMAIL);
      if (!emailInput) return;
      const email = emailInput.value.trim();
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRegex.test(email)) return;
      console.log('Lead event firing');
      if (typeof fbq === 'function') {
          fbq('track', 'Lead', { 
              content_name: 'Skin Sensitivity Quiz', 
              source: 'theoutset.com' 
          });
          console.log('Lead event fired');
      } else {
          console.warn('Facebook Pixel (fbq) not defined');
      }
  }, true);
})();

// Promobar Countdown Timer
(function() {
  let globalUpdateInterval = null;
  const countdownElements = new Map();

  /**
   * Convert US Eastern Time to UTC timestamp
   * @param {string} dateStr - Date string in MM/DD/YYYY format
   * @param {string} timeStr - Time string in HH:MM AM/PM format
   * @returns {number} UTC timestamp in milliseconds
   */
  function convertUSToUTC(dateStr, timeStr) {
    const [month, day, year] = dateStr.split('/').map(Number);
    
    const timeMatch = timeStr.match(/(\d+):(\d+)\s*(AM|PM)/i);
    if (!timeMatch) {
      console.error('Invalid time format. Expected HH:MM AM/PM');
      return null;
    }
    
    let hours = parseInt(timeMatch[1], 10);
    const minutes = parseInt(timeMatch[2], 10);
    const ampm = timeMatch[3].toUpperCase();
    
    if (ampm === 'PM' && hours !== 12) {
      hours += 12;
    } else if (ampm === 'AM' && hours === 12) {
      hours = 0;
    }
    
    const yearStr = String(year);
    const monthStr = String(month).padStart(2, '0');
    const dayStr = String(day).padStart(2, '0');
    const hourStr = String(hours).padStart(2, '0');
    const minuteStr = String(minutes).padStart(2, '0');
    
    const dateString = `${yearStr}-${monthStr}-${dayStr}T${hourStr}:${minuteStr}:00`;
    
    const testDate = new Date(dateString + 'Z'); 
    
    const formatter = new Intl.DateTimeFormat('en-US', {
      timeZone: 'America/New_York',
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      hour12: false
    });
    
    const parts = formatter.formatToParts(testDate);
    const easternYear = parseInt(parts.find(p => p.type === 'year').value, 10);
    const easternMonth = parseInt(parts.find(p => p.type === 'month').value, 10);
    const easternDay = parseInt(parts.find(p => p.type === 'day').value, 10);
    const easternHour = parseInt(parts.find(p => p.type === 'hour').value, 10);
    const easternMinute = parseInt(parts.find(p => p.type === 'minute').value, 10);
    
    const targetHour = hours;
    const targetMinute = minutes;
    
    let hourDiff = targetHour - easternHour;
    let minuteDiff = targetMinute - easternMinute;
    
    if (hourDiff < -12) hourDiff += 24;
    if (hourDiff > 12) hourDiff -= 24;
    
    let adjustedUTC = new Date(testDate.getTime() + (hourDiff * 60 * 60 * 1000) + (minuteDiff * 60 * 1000));
    
    const verifyParts = formatter.formatToParts(adjustedUTC);
    const verifyHour = parseInt(verifyParts.find(p => p.type === 'hour').value, 10);
    const verifyMinute = parseInt(verifyParts.find(p => p.type === 'minute').value, 10);
    
    if (verifyHour !== targetHour || verifyMinute !== targetMinute) {
      const finalHourDiff = targetHour - verifyHour;
      const finalMinuteDiff = targetMinute - verifyMinute;
      adjustedUTC = new Date(adjustedUTC.getTime() + (finalHourDiff * 60 * 60 * 1000) + (finalMinuteDiff * 60 * 1000));
    }
    
    return adjustedUTC.getTime();
  }

  function updateCountdown(endTime, daysEl, hoursEl, minutesEl, secondsEl, slideIndex) {
    const now = Date.now();
    const difference = endTime - now;
    
    if (difference <= 0) {
      daysEl.textContent = '00';
      hoursEl.textContent = '00';
      minutesEl.textContent = '00';
      secondsEl.textContent = '00';
      return false;
    }
    
    const days = Math.floor(difference / (1000 * 60 * 60 * 24));
    const hours = Math.floor((difference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const minutes = Math.floor((difference % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((difference % (1000 * 60)) / 1000);
    
    daysEl.textContent = String(days).padStart(2, '0');
    hoursEl.textContent = String(hours).padStart(2, '0');
    minutesEl.textContent = String(minutes).padStart(2, '0');
    secondsEl.textContent = String(seconds).padStart(2, '0');
    
    return true;
  }

  function registerCountdown(element) {
    const dateStr = element.getAttribute('data-countdown-date');
    const timeStr = element.getAttribute('data-countdown-time');
    
    if (!dateStr || !timeStr) {
      return false;
    }
    
    const endTime = convertUSToUTC(dateStr, timeStr);
    if (!endTime) {
      return false;
    }
    
    const countdownId = dateStr + '_' + timeStr + '_' + element.getAttribute('data-slide-index');
    
    countdownElements.set(countdownId, {
      element: element,
      endTime: endTime
    });
    
    return true;
  }

  function updateAllCountdowns() {
    countdownElements.forEach((data, countdownId) => {
      if (!document.body.contains(data.element)) {
        countdownElements.delete(countdownId);
        return;
      }
      
      const daysEl = data.element.querySelector('.countdown-days');
      const hoursEl = data.element.querySelector('.countdown-hours');
      const minutesEl = data.element.querySelector('.countdown-minutes');
      const secondsEl = data.element.querySelector('.countdown-seconds');
      
      if (!daysEl || !hoursEl || !minutesEl || !secondsEl) {
        countdownElements.delete(countdownId);
        registerCountdown(data.element);
        return;
      }
      
      const now = Date.now();
      const difference = data.endTime - now;
      
      if (difference <= 0) {
        daysEl.textContent = '00';
        hoursEl.textContent = '00';
        minutesEl.textContent = '00';
        secondsEl.textContent = '00';
        countdownElements.delete(countdownId);
        return;
      }
      
      const days = Math.floor(difference / (1000 * 60 * 60 * 24));
      const hours = Math.floor((difference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      const minutes = Math.floor((difference % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((difference % (1000 * 60)) / 1000);
      
      daysEl.textContent = String(days).padStart(2, '0');
      hoursEl.textContent = String(hours).padStart(2, '0');
      minutesEl.textContent = String(minutes).padStart(2, '0');
      secondsEl.textContent = String(seconds).padStart(2, '0');
    });
  }

  function startGlobalUpdate() {
    if (globalUpdateInterval) {
      clearInterval(globalUpdateInterval);
    }
    
    updateAllCountdowns();
    
    globalUpdateInterval = setInterval(updateAllCountdowns, 1000);
  }

  function initCountdown(element) {
    if (registerCountdown(element)) {
      // Start global update if not already running
      if (!globalUpdateInterval) {
        startGlobalUpdate();
      }
    }
  }

  function scanAndRegisterCountdowns() {
    const promobar = document.querySelector('.js-promobar');
    if (!promobar) return;
    
    const elements = promobar.querySelectorAll('.promobar-countdown');
    elements.forEach(element => {
      const dateStr = element.getAttribute('data-countdown-date');
      const timeStr = element.getAttribute('data-countdown-time');
      const slideIndex = element.getAttribute('data-slide-index');
      
      if (!dateStr || !timeStr) return;
      
      const countdownId = dateStr + '_' + timeStr + '_' + slideIndex;
      
      if (!countdownElements.has(countdownId)) {
        initCountdown(element);
      }
    });
  }

  function startInitialization() {
    scanAndRegisterCountdowns();
    
    startGlobalUpdate();
    
    let retries = 0;
    const maxRetries = 15;
    const retryInterval = setInterval(() => {
      retries++;
      scanAndRegisterCountdowns();
      
      if (retries >= maxRetries) {
        clearInterval(retryInterval);
      }
    }, 300);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', startInitialization);
  } else {
    startInitialization();
  }

  document.addEventListener('DOMContentLoaded', function() {
    const promobar = document.querySelector('.js-promobar');
    if (promobar) {
      const swiperContainer = promobar.querySelector('.swiper');
      if (swiperContainer) {
        setTimeout(() => {
          if (swiperContainer.swiper) {
            swiperContainer.swiper.on('slideChange', function() {
              scanAndRegisterCountdowns();
            });
          }
        }, 1000);
      }
      
      const observer = new MutationObserver(function(mutations) {
        let shouldScan = false;
        mutations.forEach(function(mutation) {
          if (mutation.addedNodes.length) {
            mutation.addedNodes.forEach(function(node) {
              if (node.nodeType === 1) {
                if (node.classList && node.classList.contains('promobar-countdown')) {
                  shouldScan = true;
                } else if (node.querySelector && node.querySelector('.promobar-countdown')) {
                  shouldScan = true;
                }
              }
            });
          }
        });
        
        if (shouldScan) {
          scanAndRegisterCountdowns();
        }
      });
      
      observer.observe(promobar, {
        childList: true,
        subtree: true
      });
    }
  });
})();

// add css on double class sections
document.addEventListener("DOMContentLoaded", function() {
  const supplySections = document.querySelectorAll('.supply-section');
  
  if (supplySections.length > 1) {
    for (let i = 0; i < supplySections.length - 1; i++) {
      const innerElement = supplySections[i].querySelector('.image-with-text');
      if (innerElement) {
        innerElement.style.paddingBottom = '0';
        innerElement.style.marginBottom = '-40px';
      }
    }
  }
});
//form loader
// document.addEventListener("DOMContentLoaded", function() {
//   const loader = document.querySelector('.form-loader');
//   const formContainer = document.querySelector('.klaviyo-form-Shm5kQ');

//   if (!loader || !formContainer) return;

//   const observer = new MutationObserver((mutations, obs) => {
//     if (formContainer.children.length > 0) {
//       loader.style.display = 'none'; // Hide the loader
//       obs.disconnect();
//     }
//   });
//   observer.observe(formContainer, { childList: true });
// });